"use client";
import { contactInfo } from "@/app/contents/contactInformation";
import { Typography } from "antd";
import Link from "next/link";
import React from "react";

const ContactInformation = () => {
  const { Title } = Typography;

  return (
    <div
      className="flex flex-col p-6 gap-10 md:gap-14  rounded-lg bg-white aspect-square md:w-1/2 max-h-80 md:max-h-full bg-[url(/assets/images/contactUsPage/background.png)] bg-cover
 bg-bottom"
    >
      <div className="flex flex-col gap-2">
        <Title level={3} className="H3 !text-xl">
          اطلاعات تماس
        </Title>
        <p className="text-regal-black !text-sm !leading-8">
          در کنار شما، برای ساختن تجربه ای بهتر
        </p>
      </div>
      <div className="flex flex-col gap-4">
        {contactInfo.map((info) => {
          const Icon = info.icon;
          const links = Array.isArray(info.link) ? info.link : [info.link];
          const titles = Array.isArray(info.title) ? info.title : [info.title];
          return links.map((href, idx) => (
            <Link href={href} key={`${info.id}-${idx}`}>
              <div
                className={`${
                  info.id === 2 ? "items-start" : "items-center"
                } flex gap-2 w-full`}
              >
                <div className="w-8 h-8 rounded-xl bg-regal-blue flex justify-center items-center">
                  <Icon className="text-white" />
                </div>
                <Title
                  level={2}
                  className="H3 flex-1 !text-base xl:!text-lg !font-normal !text-regal-blue-dark"
                >
                  {titles[idx] ?? titles[0]}
                </Title>
              </div>
            </Link>
          ));
        })}
      </div>
    </div>
  );
};

export default ContactInformation;
